function injectStyles() {
    const css = `
        .search-bar {
            position: relative;
        }
        .search-bar__suggestions {
            display: none;
            position: absolute;
            top: 100%;
            margin-top: 10px;
            left: 0;
            right: 0;
            background-color: #fff;
            border: 1px solid #e5e9ef;
            border-top: none;
            border-radius:12px;
            z-index: 10;
            max-height: 200px;
            overflow-y: auto;
        }
        .search-bar__suggestions ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }
        .search-bar__suggestions li {
            padding: 0.75rem 1.25rem;
            cursor: pointer;
            transition: background-color 0.2s ease;
            color: #000;
        }
        .search-bar__suggestions li:hover {
            background-color: #f8f9fa;
        }
    `;
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}

function showLoader() {
    let loader = document.querySelector('.search-bar__loader');
    if (!loader) {
        loader = document.createElement('div');
        loader.className = 'search-bar__loader';
        const loaderStyle = document.createElement('style');
        loaderStyle.textContent = `
            .search-bar__loader {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border: 4px solid #f3f3f3;
                border-top: 4px solid #3498db;
                border-radius: 50%;
                width: 24px;
                height: 24px;
                animation: spin 1s linear infinite;
                z-index: 11;
            }
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(loaderStyle);
        const searchBarInputGroup = document.querySelector('.search-bar__input-group');
        if (searchBarInputGroup) {
            searchBarInputGroup.appendChild(loader);
        }
    }
    loader.style.display = 'block';
}

function hideLoader() {
    const loader = document.querySelector('.search-bar__loader');
    if (loader) {
        loader.style.display = 'none';
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const searchBar = document.querySelector('.search-bar');

    if (!searchBar) {
        return;
    }

    injectStyles();

    const searchInput = searchBar.querySelector('.search-bar__input');
    const searchButton = searchBar.querySelector('.search-bar__button');
    const calculatorPageUrl = searchInput.dataset.pageWithRoofCalculator;
    let suggestionsContainer;
    let debounceTimer;

    function createSuggestionsContainer() {
        if (!suggestionsContainer) {
            suggestionsContainer = document.createElement('div');
            suggestionsContainer.classList.add('search-bar__suggestions');
            searchBar.appendChild(suggestionsContainer);
        }
    }

    function hideSuggestions() {
        if (suggestionsContainer) {
            suggestionsContainer.style.display = 'none';
        }
    }

    function displaySuggestions(suggestions) {
        console.log('displaySuggestions');
        console.log(suggestions);
        createSuggestionsContainer();
        suggestionsContainer.innerHTML = '';
        suggestionsContainer.style.display = 'block';

        if (suggestions.length === 0) {
            const li = document.createElement('li');
            li.textContent = 'No addresses found.';
            suggestionsContainer.appendChild(li);
            return;
        }

        const ul = document.createElement('ul');
        suggestions.forEach(suggestion => {
            const li = document.createElement('li');
            suggestion.Text = suggestion.Text.replace(',', ', ' + suggestion.PayLoad.PostNummer);
            li.textContent = suggestion.Text;
            li.setAttribute('data-x', suggestion.PayLoad.Posisjon.X);
            li.setAttribute('data-y', suggestion.PayLoad.Posisjon.Y);
            li.setAttribute('data-adresseid', suggestion.PayLoad.AdresseId);
            li.setAttribute('data-adressematrikkelnummer', suggestion.PayLoad.AdresseMatrikkelNummer);
            li.setAttribute('data-postnummer', suggestion.PayLoad.PostNummer);
            li.setAttribute('data-poststed', suggestion.PayLoad.PostSted);

            li.addEventListener('click', () => {
                const addressText = suggestion.Text;
                searchInput.value = addressText;
                hideSuggestions();
                const x = li.getAttribute('data-x');
                const y = li.getAttribute('data-y');
                const adresseId = li.getAttribute('data-adresseid');
                const adresseMatrikkelNummer = li.getAttribute('data-adressematrikkelnummer');
                const postnummer = li.getAttribute('data-postnummer');
                const poststed = li.getAttribute('data-poststed');
                showLoader();
                fetchBuildingData(x, y, addressText, adresseId, adresseMatrikkelNummer, postnummer, poststed);
            });
            ul.appendChild(li);
        });
        suggestionsContainer.appendChild(ul);
    }

    async function fetchBuildingData(longitude, latitude, address, adresseId, adresseMatrikkelNummer, postnummer, poststed) {
        const geometryApiKey = wdsNorkartApiData.apiKeys.geometry;
        if (!geometryApiKey) {
            console.error('Geometry API key is missing.');
            hideLoader();
            return;
        }

        const url = new URL('https://takflater.api.norkart.no/takflater/punkt');
        url.searchParams.append('X', longitude);
        url.searchParams.append('Y', latitude);
        url.searchParams.append('api_key', geometryApiKey);

        console.log('fetchBuildingData', url.toString());

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Failed to fetch building data. Status: ${response.status}`);
            }
            const data = await response.json();

            // Save data to sessionStorage and redirect
            if (data && data.length > 0) {
                const dataToStore = {
                    address: address,
                    coordinates: {
                        longitude: longitude,
                        latitude: latitude
                    },
                    adresseId: adresseId,
                    adresseMatrikkelNummer: adresseMatrikkelNummer,
                    buildings: data,
                    postnummer: postnummer,
                    poststed: poststed,
                };
                sessionStorage.setItem('norkartBuildingData', JSON.stringify(dataToStore));
                window.location.href = calculatorPageUrl;
            } else {
                // Handle cases where no building data is found for the coordinates
                console.log('No building data found for the selected address.');
                // Maybe show a message to the user here
            }
        } catch (error) {
            console.error('Error fetching building data:', error);
        } finally {
            hideLoader();
        }
    }

    async function fetchAddressSuggestions(query) {
        if (query.length < 3) {
            hideSuggestions();
            return;
        }

        if (typeof wdsNorkartApiData === 'undefined' || !wdsNorkartApiData.apiKeys || !wdsNorkartApiData.apiKeys.address) {
            console.error('Address API key is not available.');
            return;
        }
        const apiKey = wdsNorkartApiData.apiKeys.address;

        const url = new URL('https://fritekstsok.api.norkart.no/suggest/matrikkel/adresse');
        url.searchParams.append('Query', query);
        url.searchParams.append('api_key', apiKey);
        url.searchParams.append('limit', 5);
        url.searchParams.append('filtrer', 'representasjonspunkt');

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            displaySuggestions(data.Options || []);
        } catch (error) {
            console.error('Error fetching address suggestions:', error);
            hideSuggestions();
        }
    }

    function debounce(callback, delay) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(callback, delay);
    }

    searchInput.addEventListener('input', function (event) {
        const query = event.target.value;
        debounce(() => fetchAddressSuggestions(query), 300);
    });

    searchButton.addEventListener('click', function () {
        const selectedAddress = searchInput.value;

        if (selectedAddress && calculatorPageUrl) {
            window.location.href = `${calculatorPageUrl}?address=${encodeURIComponent(selectedAddress)}`;
        }
    });

    document.addEventListener('click', function (event) {
        if (!searchBar.contains(event.target)) {
            hideSuggestions();
        }
    });
}); 
